import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

const footerLinks = {
  Products: [
    { name: "PVC Dividing Walls", path: "/products" },
    { name: "Sliding Curtains", path: "/products" },
    { name: "Industrial Covers", path: "/products" },
    { name: "Welding Screens", path: "/products" },
    { name: "Acoustic Curtains", path: "/products" },
  ],
  Company: [
    { name: "About Us", path: "/about" },
    { name: "Industries", path: "/industries" },
    { name: "Contact", path: "/contact" },
  ],
  Resources: [
    { name: "Blog & Insights", path: "/blog" },
    { name: "Free Guides", path: "/guides" },
    { name: "Request a Quote", path: "/quote" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-[#2E2E2E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <img src="/logo-white.png" alt="NG Industries" className="h-12 w-auto" />
            </Link>
            <p className="text-[#A3A3A3] text-sm leading-relaxed mb-6 max-w-sm">
              Australia's trusted manufacturer of industrial textile solutions. 
              Custom PVC walls, curtains, and covers engineered for performance.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm text-[#A3A3A3]">
                <MapPin size={16} className="text-[#FF5722] mt-0.5 shrink-0" />
                <span>8 Blamey Place, O'Connor, Western Australia</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#A3A3A3]">
                <Phone size={16} className="text-[#FF5722] shrink-0" />
                <span>+61 413 136 160</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#A3A3A3]">
                <Mail size={16} className="text-[#FF5722] shrink-0" />
                <span>office@ngindustries.com.au</span>
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-[#A3A3A3] text-sm hover:text-[#FF5722] transition-colors duration-200 flex items-center gap-1 group"
                    >
                      {link.name}
                      <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#2E2E2E] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#A3A3A3] text-xs">
            &copy; {new Date().getFullYear()} NG Industries. All rights reserved. Australian Made.
          </p>
          <div className="flex items-center gap-6 text-xs text-[#A3A3A3]">
            <span>ABN: 12 345 678 901</span>
            <span>|</span>
            <span>Privacy Policy</span>
            <span>|</span>
            <span>Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
